let initState = {
  getAllCourses: false,
  courses: []
};

/**
 *
 * Reducer of dashboard statistics
 *
 * @param {*} state
 * @param {*} action
 * @returns
 */
export default function (state = initState, action) {
  switch (action.type) {
    case 'TIMING_STATISTICS':
      return {
        ...state,
        timing: action.payload
      };

    case 'SESSIONS_STATISTICS':
      return {
        ...state,
        sessions: action.payload
      };

    case 'CATEGORIES_STATISTICS':
      return {
        ...state,
        categories: action.payload
      };

    case 'COURSES_STATISTICS':
      return {
        ...state,
        courses: action.payload
      };


    case 'ARTICLES_STATISTICS':
      return {
        ...state,
        articles: action.payload
      };

    case 'PROFIT_STATISTICS':
      return {
        ...state,
        profit: action.payload
      };

    case 'PROFIT_CHART':
      return {
        ...state,
        profitChart: action.payload
      };

    default:
      return { ...state };
  }
}
